<template>
  <div class="leaderBox">
    <div class="leaderList">
      <!-- 左边 -->
      <div class="leader_left">
        <p>评委中心</p>
        <p class="leader_leftP leader_leftP2">作品列表</p>
        <p class="leader_leftP">领导审核</p>
      </div>
      <!-- 右边 -->
      <div class="leader_right">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="全部" name="first"></el-tab-pane>
          <el-tab-pane label="未评分" name="second"></el-tab-pane>
          <el-tab-pane label="已评分" name="third"></el-tab-pane>
        </el-tabs>
        <div class="leader_search">
          <p>活动名称</p>
          <el-input v-model="leaderSearch" placeholder="请输入内容"></el-input>
          <el-button type="text">查询</el-button>
        </div>
        <!-- 全部 -->
        <div v-show="activeName == 'first'">
          <el-table
            :data="tableData"
            stripe
            style="width: 100%">
            <el-table-column
              prop="number"
              label="序号"
              align="center">
            </el-table-column>
            <el-table-column
              prop="activeName"
              label="活动名称"
              align="center"
              width="370">
            </el-table-column>
            <el-table-column
              prop="workName"
              align="center"
              label="作品名称"
              width="200">
            </el-table-column>
            <el-table-column
              prop="workClass"
              align="center"
              label="作品类别">
            </el-table-column>
            <el-table-column
              prop="enType"
              align="center"
              label="评分状态">
            </el-table-column>
            <el-table-column
              prop="leaderEn"
              align="center"
              label="评委评分">
            </el-table-column>
            <el-table-column
              prop="address"
              align="center"
              label="操作">
              <template slot-scope="scope">
                <el-button type="text" size="small">作品打分</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            background
            layout="prev, pager, next"
            :total="1000">
          </el-pagination>
        </div>
        <!-- 未评分 -->
        <div v-show="activeName == 'second'">
          <el-table
            :data="tableDataNo"
            stripe
            style="width: 100%">
            <el-table-column
              prop="number"
              label="序号"
              align="center">
            </el-table-column>
            <el-table-column
              prop="activeName"
              label="活动名称"
              align="center"
              width="370">
            </el-table-column>
            <el-table-column
              prop="workName"
              align="center"
              label="作品名称"
              width="200">
            </el-table-column>
            <el-table-column
              prop="workClass"
              align="center"
              label="作品类别">
            </el-table-column>
            <el-table-column
              prop="enType"
              align="center"
              label="评分状态">
            </el-table-column>
            <el-table-column
              prop="leaderEn"
              align="center"
              label="评委评分">
            </el-table-column>
            <el-table-column
              prop="address"
              align="center"
              label="操作">
              <template slot-scope="scope">
                <el-button type="text" size="small">作品打分</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            background
            layout="prev, pager, next"
            :total="1000">
          </el-pagination>
        </div>
        <!-- 已评分 -->
        <div v-show="activeName == 'third'">
          <el-table
            :data="tableDataYes"
            stripe
            style="width: 100%">
            <el-table-column
              prop="number"
              label="序号"
              align="center">
            </el-table-column>
            <el-table-column
              prop="activeName"
              label="活动名称"
              align="center"
              width="370">
            </el-table-column>
            <el-table-column
              prop="workName"
              align="center"
              label="作品名称"
              width="200">
            </el-table-column>
            <el-table-column
              prop="workClass"
              align="center"
              label="作品类别">
            </el-table-column>
            <el-table-column
              prop="enType"
              align="center"
              label="评分状态">
            </el-table-column>
            <el-table-column
              prop="leaderEn"
              align="center"
              label="评委评分">
            </el-table-column>
            <el-table-column
              prop="address"
              align="center"
              label="操作">
              <template slot-scope="scope">
                <el-button type="text" size="small">作品打分</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            background
            layout="prev, pager, next"
            :total="1000">
          </el-pagination>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
export default {
  name: "leaderList",
  data() {
    return {
      activeName: 'first',
      leaderSearch:'',
      tableData: [
        {
          number: '1',
          activeName: '「营养新未来 由你来定义」汤臣倍健产品焕新设计大赛',
          workName: '共享3D打印工坊',
          workClass: '3D建模',
          enType: '已评分',
          leaderEn: '100',
        },
        {
          number: '2',
          activeName: '「营养新未来 由你来定义」汤臣倍健产品焕新设计大赛',
          workName: '共享3D打印工坊',
          workClass: '3D建模',
          enType: '已评分',
          leaderEn: '100',
        },
        {
          number: '3',
          activeName: '「营养新未来 由你来定义」汤臣倍健产品焕新设计大赛',
          workName: '共享3D打印工坊',
          workClass: '3D建模',
          enType: '已评分',
          leaderEn: '100',
        },
        {
          number: '4',
          activeName: '「营养新未来 由你来定义」汤臣倍健产品焕新设计大赛',
          workName: '共享3D打印工坊',
          workClass: '3D建模',
          enType: '已评分',
          leaderEn: '100',
        },
        {
          number: '5',
          activeName: '「营养新未来 由你来定义」汤臣倍健产品焕新设计大赛',
          workName: '共享3D打印工坊',
          workClass: '3D建模',
          enType: '已评分',
          leaderEn: '100',
        },

      ],
      tableDataNo: [
        {
          number: '1',
          activeName: '「营养新未来 由你来定义」汤臣倍健产品焕新设计大赛',
          workName: '共享3D打印工坊',
          workClass: '3D建模',
          enType: '已评分',
          leaderEn: '100',
        },
        {
          number: '2',
          activeName: '「营养新未来 由你来定义」汤臣倍健产品焕新设计大赛',
          workName: '共享3D打印工坊',
          workClass: '3D建模',
          enType: '已评分',
          leaderEn: '100',
        },
        {
          number: '3',
          activeName: '「营养新未来 由你来定义」汤臣倍健产品焕新设计大赛',
          workName: '共享3D打印工坊',
          workClass: '3D建模',
          enType: '已评分',
          leaderEn: '100',
        },
        {
          number: '4',
          activeName: '「营养新未来 由你来定义」汤臣倍健产品焕新设计大赛',
          workName: '共享3D打印工坊',
          workClass: '3D建模',
          enType: '已评分',
          leaderEn: '100',
        },
        {
          number: '5',
          activeName: '「营养新未来 由你来定义」汤臣倍健产品焕新设计大赛',
          workName: '共享3D打印工坊',
          workClass: '3D建模',
          enType: '已评分',
          leaderEn: '100',
        },

      ],
      tableDataYes: [
        {
          number: '1',
          activeName: '「营养新未来 由你来定义」汤臣倍健产品焕新设计大赛',
          workName: '共享3D打印工坊',
          workClass: '3D建模',
          enType: '已评分',
          leaderEn: '100',
        },
        {
          number: '2',
          activeName: '「营养新未来 由你来定义」汤臣倍健产品焕新设计大赛',
          workName: '共享3D打印工坊',
          workClass: '3D建模',
          enType: '已评分',
          leaderEn: '100',
        },
        {
          number: '3',
          activeName: '「营养新未来 由你来定义」汤臣倍健产品焕新设计大赛',
          workName: '共享3D打印工坊',
          workClass: '3D建模',
          enType: '已评分',
          leaderEn: '100',
        },
        {
          number: '4',
          activeName: '「营养新未来 由你来定义」汤臣倍健产品焕新设计大赛',
          workName: '共享3D打印工坊',
          workClass: '3D建模',
          enType: '已评分',
          leaderEn: '100',
        },
        {
          number: '5',
          activeName: '「营养新未来 由你来定义」汤臣倍健产品焕新设计大赛',
          workName: '共享3D打印工坊',
          workClass: '3D建模',
          enType: '已评分',
          leaderEn: '100',
        },

      ],

    };
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    }
  },
};
</script>

<style scoped lang="less">
.leaderBox {
  background: rgba(249, 249, 249);
  padding: 20px 42px;
  .leaderList {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    .leader_left {
      width: 169px;
      background: #fff;
      border-radius: 4px;
      margin-right: 20px;
      flex-shrink: 0;
      p {
        padding: 12px 9px;
        color: #157EFB;
      }
      .leader_leftP {
        font-size: 14px;
        color: #000;
        cursor: pointer;
      }
      .leader_leftP2 {
        background: rgb(159 200 249 / 39%);
        color: #157EFB;
      }

    }
    .leader_right {
      background: #fff;
      width: 100%;
      padding: 17px 21px 35px;
      box-sizing: border-box;
      position: relative;
      /deep/.el-table th.el-table__cell {
        background: rgba(156, 201, 255);
        color: #000;
      }
      /deep/.el-pagination {
        text-align: right;
        margin-top: 57px;
      }
      .leader_search {
        display: flex;
        align-items: center;
        position: absolute;
        top: 9px;
        right: 20px;
        p {
          color: #262626;
          font-size: 14px;
          margin-right: 5px;
        }
        /deep/.el-input {
          width: 121px;
          height: 30px;
          border-radius: 4px;
          margin-right: 20px;
        }
        /deep/.el-input__inner {
          width: 121px;
          height: 30px;
          border-radius: 4px;
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/design/activeList/leaderList.vue